import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";
import Header from "@/components/Header";
import HeroCarousel from "@/components/HeroCarousel";
import SiddhaMalaFeature from "@/components/SiddhaMalaFeature";
import ShravanGrid from "@/components/ShravanGrid";
import ExhibitionHero from "@/components/ExhibitionHero";
import ComboKitsMarquee from "@/components/ComboKits";
import ShravanOfferBlog from "@/components/ShravanOfferBlog";
import RareCollection from "@/components/RareCollection";
import Experts from "@/components/Experts";
import TrustedBy from "@/components/TrustedBy";
import Blogs from "@/components/Blogs";
import Anniversary from "@/components/Anniversary";
import MediaFeatured from "@/components/MediaFeatured";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Home = () => {
  const [d, setD] = useState({
    settings: {}, hero: [], sankalp: [], rare: [], exhibitions: [], combo: [],
    experts: [], testimonials: [], media: [], blogs: [], loading: true,
  });

  useEffect(() => {
    (async () => {
      try {
        const [settings, hero, sankalp, rare, exhibitions, combo, experts, testimonials, media, blogs] = await Promise.all([
          publicApi.settings(),
          publicApi.list("hero_banners"),
          publicApi.list("sankalp_pujas"),
          publicApi.list("rare_collection"),
          publicApi.list("exhibitions"),
          publicApi.list("combo_kits"),
          publicApi.list("experts"),
          publicApi.list("testimonials"),
          publicApi.list("media_features"),
          publicApi.list("blogs"),
        ]);
        setD({ settings, hero, sankalp, rare, exhibitions, combo, experts, testimonials, media, blogs, loading: false });
      } catch (e) {
        console.error(e);
        setD((s) => ({ ...s, loading: false }));
      }
    })();
  }, []);

  const s = d.settings;
  // Default true — if setting missing, section shows (backward-compat)
  const show = (k) => s[k] !== false;

  return (
    <div className="min-h-screen bg-[#FAF6F0]">
      {!d.loading && (
        <Header brand={s.brand_name} tagline={s.tagline || "Rudraksha power for you"} logo={s.logo_image} />
      )}
      {d.loading && (
        <div className="h-16 md:h-20 bg-[#FAF6F0] border-b border-[rgba(45,40,37,0.08)]" />
      )}
      <HeroCarousel banners={d.hero} speed={s.hero_speed_seconds ?? 3} />
      {show("show_siddha_mala") && <SiddhaMalaFeature settings={s} />}
      {show("show_shravan_pujas") && (
        <ShravanGrid
          items={d.sankalp}
          kicker={s.shravan_pujas_kicker}
          title={s.shravan_pujas_title || "Sacred Sankalp Pujas"}
          subtitle={s.shravan_pujas_subtitle}
        />
      )}
      {show("show_exhibition") && <ExhibitionHero settings={s} />}
      {show("show_combo_kits") && <ComboKitsMarquee items={d.combo} settings={s} />}
      {show("show_shravan_offer") && <ShravanOfferBlog settings={s} />}
      {show("show_rare_collection") && <RareCollection items={d.rare} settings={s} />}
      {show("show_experts") && <Experts items={d.experts} settings={s} speed={s.experts_speed_seconds ?? 4} />}
      {show("show_anniversary") && <Anniversary settings={s} />}
      {show("show_trusted") && <TrustedBy items={d.testimonials} settings={s} />}
      {show("show_blogs") && <Blogs items={d.blogs} settings={s} />}
      {show("show_media") && <MediaFeatured items={d.media} />}
      {show("show_faq") && <FAQ faqs={s.faqs || []} settings={s} />}
      <Footer settings={s} />
      <WhatsAppFloat number={s.whatsapp_number} />
    </div>
  );
};

export default Home;
